import { AppShell, Loader } from '@mantine/core';
import { useUnit } from 'effector-react';
import { accountPageModel } from '../../model';
import { AccountPageEmpty } from '../account-page-empty';
import { AccountPageHeading } from '../account-page-heading';
import { AccountPageTabs } from '../account-page-tabs';
import cls from './account-page.module.scss';

export const AccountPage = () => {
	const [empty, current, pending] = useUnit([
		accountPageModel.$empty,
		accountPageModel.$currentTab,
		accountPageModel.$pending,
	]);

	return (
		<AppShell.Main
			className={cls.accountPage}
			data-tab={current}
		>
			{empty && !pending && <AccountPageEmpty />}
			{pending && <Loader />}
			{!empty && !pending && (
				<>
					<AccountPageHeading />
					<AccountPageTabs />
				</>
			)}
		</AppShell.Main>
	);
};
